import { type FC } from 'react';
import {
  UiBox,
  type UiBoxProps, UiHStack, UiIconClosedCaptioning, UiIconHardDrives,
  UiStack,
  uiStyles, UiText,
} from '@/lib/ui';
import AddonCard, { type AddonCardProps } from './AddonCard';
import BaseDividerHorizontal from '@/base/Divider/Horizontal';
import { type account } from '@/api';
import { isAddonEnabled } from '@/account/subscription/utils';
import { SubscriptionProduct } from '@/api/constant/subscription';
import PriceDisplay from '@/account/component/Subscription/PriceDisplay';
import AILiveCaptioningCard from '@/base/App/AILiveCaptioningCard';
import { UiTooltip } from '@/lib/ui/Tooltip';

export interface AILiveCaptioningProps extends UiBoxProps {
  subscription?: account.Subscription
  onToggle?: AddonCardProps['onToggle']
}

const AILiveCaptioning: FC<AILiveCaptioningProps> = ({
  onToggle = undefined,
  subscription = undefined,
  ...props
}) => {
  return (
    <AddonCard
      onToggle={onToggle}
      isEnabled={subscription ? isAddonEnabled(subscription, SubscriptionProduct.AILiveCaptioning) : false}
      {...props}
    >
      <UiStack spacing={0} borderRadius={uiStyles.borderRadius}>
        <UiHStack justifyContent={'space-between'}>
          <UiTooltip
            label={'Provide AI powered captions to live streams'}
            borderRadius={uiStyles.borderRadius}
            p={2}
            px={4}
          >
            <UiBox {...uiStyles.hover}>
              <AILiveCaptioningCard />
            </UiBox>
          </UiTooltip>
          {subscription && (
            <UiStack spacing={0} alignItems={'flex-end'}>
              <UiStack>
                <PriceDisplay price={subscription.products[SubscriptionProduct.AILiveCaptioning].monthlyPrice * 3} suffix={' / 3 months'} />
              </UiStack>
              <UiHStack>
                <UiText color={'text.secondary'}>+ usage</UiText>
              </UiHStack>
            </UiStack>
          )}
        </UiHStack>
        {/* <BaseDividerHorizontal height={4} /> */}
        {/* <UiText variant='body1' color={'text.secondary'}>Provide AI powered captions to live streams</UiText> */}
      </UiStack>
    </AddonCard>
  );
};

export default AILiveCaptioning;
